import React from 'react'
import i18n from 'i18next'

const ScheduleStatusLabel = ({ status }) => {
    switch (status) {
        case 'complete':
            return (
                <div className="email-builder-status-label success">
                    <i className="far fa-circle-check" />

                    <p>{i18n.t('sch_email_status_columns_sending_complete')}</p>
                </div>
            )
        case 'sending':
            return (
                <div className="email-builder-status-label warning">
                    <i className="far fa-timer" />

                    <p>{i18n.t('sch_email_status_columns_currently_sending')}</p>
                </div>
            )
        case 'paused':
            return (
                <div className="email-builder-status-label error">
                    <i className="fas fa-pause" />

                    <p>{i18n.t('sch_email_status_columns_schedule_paused')}</p>
                </div>
            )
        case 'cancelled':
            return (
                <div className="email-builder-status-label error">
                    <i className="fas fa-stop" />

                    <p>{i18n.t('sch_email_status_columns_schedule_cancelled')}</p>
                </div>
            )
        case 'scheduled':
            return (
                <div className="email-builder-status-label blue">
                    <i className="far fa-calendar-check" />

                    <p>{i18n.t('sch_email_status_columns_scheduled2send')}</p>
                </div>
            )
        case 'processing':
            return (
                <div className="email-builder-status-label grey">
                    <p>{i18n.t('downloadModal.processing')}</p>
                </div>
            )
        default:
            return (
                <div className="email-builder-status-label grey">
                    <i className="far fa-calendar" />

                    <p>{i18n.t('sch_email_status_columns_draft')}</p>
                </div>
            )
    }
}

export default ScheduleStatusLabel
